<div class="login-form mb-10">
  <h1 class="text-3xl uppercase !leading-snug md:text-4xl">{{ 'title_forget_password' | translate }}</h1>
  <p class="text-base font-bold leading-normal text-white-dark">{{ 'description_forget_password' | translate }}</p>
</div>
<form class="space-y-5 pb-32 dark:text-white" [formGroup]="fgForm" (ngSubmit)="onSubmit()" autocomplete="off">
  <div class="login-form">
    <label for="Email">{{ 'form_label_email' | translate }}</label>
    <div class="relative text-white-dark">
      <input
        autocomplete="off"
        formControlName="email"
        id="Email"
        type="email"
        placeholder="{{ 'form_label_email_placeholder' | translate }}"
        class="form-input ps-10 placeholder:text-white-dark"
        [class.is-invalid]="isSubmitted && fgForm.controls['email'].invalid"
      />
      <span class="absolute start-4 top-1/2 -translate-y-1/2">
        <i class="fa-solid fa-envelope"></i>
      </span>
    </div>
    @if (isSubmitted && fgForm.controls['email'].hasError('pattern')) {
    <div class="text-danger">
      {{ 'form_email_valid_msg' | translate }}
    </div>
    } @if (isSubmitted && fgForm.controls['email'].hasError('required')) {
    <div class="text-danger">
      {{ 'form_email_req_msg' | translate }}
    </div>
    } @if (isSubmitted && fgForm.controls['email'].hasError('email')) {
    <div class="text-danger">
      {{ 'form_email_valid_msg' | translate }}
    </div>
    }
  </div>

  <button type="submit" class="btn btn-primary login-form !mt-6 w-full border-0 uppercase shadow-[0_10px_20px_-10px_rgba(67,97,238,0.44)]">
    {{ 'submit' | translate }}
  </button>

  <div class="login-form-btn-secondary text-center" routerLink="/login">
    <span class="text-white-dark hover:text-blue-500">&lt;</span>
    <a routerLink="/login" class="text-white-dark hover:text-blue-500">
      {{ 'login_link' | translate }}
    </a>
  </div>
</form>

@if (loading) {
<app-loader></app-loader>
}
